import Api from '@/services/Api'

export default {
  createSession (params) {
    return Api().post('session/create', params)
  },

  listSessions () {
    return Api().get('sessions/list')
  },
  searchSessions (params) {
    return Api().get('sessions/search', { params })
  },

  fetchTimes (sessionId, params) {
    return Api().get('session/' + sessionId + '/times', { params })
  },

  addTime (sessionId, params) {
    return Api().put('session/' + sessionId + '/add_time', params)
  },

  deleteTime (sessionId, scrambleId, params) {
    return Api().delete('session/' + sessionId + '/times/' + scrambleId, params)
  },

  resetPassword (sessionId, params) {
    return Api().put('session/' + sessionId + '/reset_password', params)
  },

  inviteUser (sessionId, params) {
    return Api().get('session/' + sessionId + '/invite', { params })
  },

  addOwner (sessionId, params) {
    return Api().put('session/' + sessionId + '/add_owner', params)
  },

  acceptInvite (sessionId, authToken, params) {
    return Api().post('session/' + sessionId + '/invite/' + authToken, params)
  },

  sendChatMessage (sessionId, params) {
    return Api().post('session/' + sessionId + '/chat', params)
  }
}
